module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return (_vm.totalPages > 1) ? _c('div', [_c('ul', {
    staticClass: "uk-pagination uk-flex-center uk-flex-right@m",
    attrs: {
      "uk-margin": ""
    }
  }, [(_vm.windowStart > 1 && !_vm.notEnoughPages) ? [_c('li', {
    class: {
      'uk-active': _vm.isOnFirstPage
    }
  }, [_c('a', {
    on: {
      "click": function($event) {
        return _vm.loadPage(1)
      }
    }
  }, [_c('span', [_vm._v("1")])])]), _vm._v(" "), _c('li', {
    class: {
      'uk-active': _vm.isOnFirstPage
    }
  }, [_c('a', {
    on: {
      "click": function($event) {
        return _vm.loadPage('prev')
      }
    }
  }, [_c('span', {
    attrs: {
      "uk-pagination-previous": ""
    }
  })])])] : _vm._e(), _vm._v(" "), (_vm.notEnoughPages) ? [_vm._l((_vm.totalPages), function(n) {
    return [_c('li', {
      class: {
        'uk-active': _vm.isCurrentPage(n)
      }
    }, [_c('a', {
      on: {
        "click": function($event) {
          return _vm.loadPage(n)
        }
      }
    }, [_c('span', {
      domProps: {
        "innerHTML": _vm._s(n)
      }
    })])])]
  })] : [_vm._l((_vm.windowSize), function(n) {
    return [_c('li', {
      class: {
        'uk-active': _vm.isCurrentPage(_vm.windowStart + n - 1)
      }
    }, [_c('a', {
      on: {
        "click": function($event) {
          return _vm.loadPage(_vm.windowStart + n - 1)
        }
      }
    }, [_c('span', {
      domProps: {
        "innerHTML": _vm._s(_vm.windowStart + n - 1)
      }
    })])])]
  })], _vm._v(" "), ((_vm.windowSize + _vm.windowStart <= _vm.totalPages) && !_vm.notEnoughPages) ? [_c('li', {
    class: {
      'uk-active': _vm.isOnLastPage
    }
  }, [_c('a', {
    on: {
      "click": function($event) {
        return _vm.loadPage('next')
      }
    }
  }, [_c('span', {
    attrs: {
      "uk-pagination-next": ""
    }
  })])]), _vm._v(" "), _c('li', {
    class: {
      'uk-active': _vm.isOnLastPage
    }
  }, [_c('a', {
    on: {
      "click": function($event) {
        return _vm.loadPage(_vm.totalPages)
      }
    }
  }, [_vm._v(_vm._s(_vm.totalPages))])])] : _vm._e()], 2)]) : _vm._e()
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-4bc5bef9","hasScoped":true}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./components/shop/ShopItemsPagination.vue
// module id = 54
// module chunks = 0